/*============================*/
/* Update main product image. */
/*============================*/
jQuery(function($) {
    // get image size:
    productImageWidth = Math.ceil($('.product-photo-container').width());


    /* Placeholder JS */
    /*==========================*/
    var test = document.createElement('input');
    if (!('placeholder' in test)) {
        $('[placeholder]').each(function(){
        if ($(this).val() === '') {
            var hint = $(this).attr('placeholder');
            $(this).val(hint).addClass('hint');
        }
        });
        $('[placeholder]').focus(function() {
        if ($(this).val() === $(this).attr('placeholder')) {
            $(this).val('').removeClass('hint');
        }
        }).blur(function() {
        if ($(this).val() === '') {
            $(this).val($(this).attr('placeholder')).addClass('hint');
        }
        });
    }

    /* Form validation JS */
    /*==========================*/

    $('input.error, textarea.error').focus(function() {
        $(this).removeClass('error');
    });

    $('form :submit').click(function() {
        $(this).parents('form').find('input.hint, textarea.hint').each(function() {
        $(this).val('').removeClass('hint');
        });
        return true;
    });

    /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
    /*==========================*/

    var supportsSVG = function() {
        return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
    }
    if (!supportsSVG()) {
        $('img[src*=".svg"]').remove();
    }
});
